import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from "react";
import Button from "./Button";
import { DownloadIcon } from "./utils/IconFactory";
export default React.memo(function ToPrintButton({ children, documentTitle, elements, inseparable, excludes = [], size = 'small', color, name, className = '', }) {
    const useNewWindowMethod = navigator.userAgent.match('CriOS');
    const onClick = useCallback(async (evt) => {
        var _a, _b;
        const PRINTED_FRAME_NAME = 'printed';
        let content = '';
        let parentClasses = '';
        for (let i = 0; i < elements.length; i++) {
            const item = document.querySelector(elements[i]);
            if (!item)
                continue;
            content += item.innerHTML;
            parentClasses += ` ${item.className}`;
        }
        let cssRules = '';
        for (let s in document.styleSheets) {
            const sheet = document.styleSheets[s];
            if (sheet.href && !sheet.href.includes(location.origin) || !sheet.cssRules)
                continue;
            for (let i = 0; i < sheet.cssRules.length; i++) {
                const cssRule = sheet.cssRules[i];
                cssRules += `\n` + (cssRule.cssText || '');
            }
        }
        let mobilePrintWindow = null;
        let frameWindow = null;
        let frameDocument = null;
        if (useNewWindowMethod) {
            mobilePrintWindow = window.open('', '_blank');
        }
        else {
            document.querySelectorAll(`[name="${PRINTED_FRAME_NAME}"]`).forEach(frame => { var _a; return (_a = frame.remove) === null || _a === void 0 ? void 0 : _a.call(frame); });
            const frame = document.createElement('iframe');
            frame.name = PRINTED_FRAME_NAME;
            frame.style.position = "absolute";
            frame.style.top = "-10000px";
            frame.style.width = "100vw";
            (_b = (_a = document.body).appendChild) === null || _b === void 0 ? void 0 : _b.call(_a, frame);
            frameWindow = frame.contentWindow || frame.contentDocument;
            frameDocument = (frameWindow === null || frameWindow === void 0 ? void 0 : frameWindow.document) || frameWindow;
            frameDocument === null || frameDocument === void 0 ? void 0 : frameDocument.open();
        }
        ((mobilePrintWindow === null || mobilePrintWindow === void 0 ? void 0 : mobilePrintWindow.document) || frameDocument).write(`
      <html data-theme="light">
        <head>
          <style>

            ${cssRules}

            @media print {

              @page {
                size: A4 !important;
                margin: 0.5cm 3rem;
              }

              @page :first {
                margin-top: 0cm !important;
              }

              html,
              body {
                  // width: 100vw !important;
                  height: auto !important;
                  min-height: auto;
                  margin: 0 !important;
                  padding: 1.425rem 0 !important;
                  -webkit-print-color-adjust: exact !important;
                  print-color-adjust: exact !important;
                  background-color: transparent !important;
              }


              .pdf-parent {
                position: relative !important;
                margin: 0 !important;
                border: none !important;
                box-shadow: none !important;
                z-index: 9999;
              }

              .pdf-parent .pdf-title {
                font-weight: normal;
              }

              .pdf-parent * {
                box-shadow: none !important;
              }

              p,
              .marker,
              li,
              .list-item {
                page-break-inside: avoid;
              }

              .aspect-item,
              .block-item,
              .signal-item,
              .lifehack-item,
              .trends,
              .block {
                // page-break-before: avoid;
                page-break-inside: avoid;
              }

              h2 {
                page-break-after: avoid;
              }

              ${(inseparable === null || inseparable === void 0 ? void 0 : inseparable.length) && `
                  ${inseparable === null || inseparable === void 0 ? void 0 : inseparable.join(",")} {
                    page-break-inside: avoid !important;
                    page-break-after: avoid !important;
                  }
                `}

              ${excludes.join(",")} {
                display: none !important;
              }
            }
          </style>
        </head>
        <body class="pdf-parent">
            ${documentTitle ? `<h1 class="pdf-title">${documentTitle}</h1>` : ''}
          ${content}
        </body>
      </html>
    `);
        ((mobilePrintWindow === null || mobilePrintWindow === void 0 ? void 0 : mobilePrintWindow.document) || frameDocument).close();
        if (useNewWindowMethod) {
            mobilePrintWindow.focus();
            mobilePrintWindow.print();
            await new Promise(resolve => mobilePrintWindow.addEventListener('afterprint', () => resolve(true), { once: true }));
            mobilePrintWindow.close();
        }
        else {
            setTimeout(function () {
                window.frames[PRINTED_FRAME_NAME].focus();
                frameWindow === null || frameWindow === void 0 ? void 0 : frameWindow.print();
            }, 500);
        }
    }, [elements, excludes]);
    return (_jsxs(Button, { name: name, className: `${className} ui-print-button`, size: size, color: color, onClick: onClick, children: [_jsx(DownloadIcon, { width: "1.5rem", height: "1.5rem" }), _jsx("span", { children: children }), "\u00A0"] }));
});
